import React from "react";
import { Mail, Smartphone } from "lucide-react";

const LABELS = { sms: "Text message (SMS)", email: "Email" };

export default function ChannelPicker({ channels, value, onChange, disabled }) {
  return (
    <div className="max-w-md mx-auto mb-2" data-testid="channel-picker">
      <p className="text-[var(--vault-text-muted)] text-sm sm:text-base mb-5" data-testid="owner-email-note">
        {channels.length > 1
          ? "Choose where to receive your 6-digit code. It is valid for 10 minutes."
          : "We'll send a 6-digit code to the contact registered for this bottle. It is valid for 10 minutes."}
      </p>
      <div className="space-y-2.5" role="radiogroup">
        {channels.map((c) => {
          const Icon = c.type === "sms" ? Smartphone : Mail;
          const active = value === c.type;
          return (
            <button
              key={c.type}
              type="button"
              role="radio"
              aria-checked={active}
              disabled={disabled}
              onClick={() => onChange(c.type)}
              data-testid={`channel-${c.type}`}
              className="w-full flex items-center gap-4 px-4 py-3.5 rounded-lg text-left transition-colors duration-200"
              style={{
                background: active ? "rgba(197,160,89,0.10)" : "var(--vault-bg)",
                border: `1px solid ${active ? "rgba(197,160,89,0.6)" : "var(--vault-border)"}`,
              }}
            >
              <Icon className="w-5 h-5 shrink-0" style={{ color: active ? "var(--vault-gold)" : "var(--vault-text-muted)" }} />
              <span className="flex-1 min-w-0">
                <span className="block text-sm text-white">{LABELS[c.type]}</span>
                <span className="block text-xs font-mono-vault text-[var(--vault-text-muted)] truncate" data-testid={c.type === "email" ? "owner-email-masked" : "owner-phone-masked"}>{c.masked}</span>
              </span>
              <span className="w-4 h-4 rounded-full border flex items-center justify-center" style={{ borderColor: active ? "var(--vault-gold)" : "var(--vault-border)" }}>
                {active && <span className="w-2 h-2 rounded-full" style={{ background: "var(--vault-gold)" }} />}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
